import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { ReactComponent as EnabledIcon } from 'assets/images/payment-type-enabled.svg';
import { ReactComponent as DisabledIcon } from 'assets/images/payment-type-disabled.svg';

import styles from './PaymentCapabilities.module.scss';

const PaymentMethodStatusBadge = ({ label, enabled }) => (
  <span
    className={clsx(styles.badge, enabled ? styles.badgeEnabled : styles.badgeDisabled)}
  >
    {enabled ? (
      <EnabledIcon className={styles.badgeIcon} aria-hidden />
    ) : (
      <DisabledIcon className={styles.badgeIcon} aria-hidden />
    )}
    <span className={styles.badgeLabel}>{label}</span>
  </span>
);

PaymentMethodStatusBadge.propTypes = {
  label: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
};

export default PaymentMethodStatusBadge;
